module.exports = __webpack_public_path__ + "img/primatama.5f466880.jpg";